import {checkPerms, RequiredPermissions} from "./permissions";
import {getGlobalState} from "../constants/GlobalStore";

export const RequiredPermission = RequiredPermissions;

export function hasPermission(required) {
  const perms = getGlobalState('perms') || {};
  return checkPerms(perms, required);
}

export const PermissionDisplayList = {
  // applications: {
  //   display: "Applications",
  //   values: [
  //     {value: 1, label: "View"},
  //     {value: 2, label: "Edit"},
  //   ]
  // },
  calendar: {
    display: "Appt Calendar",
    values: [
      {value: 1, label: "Self-View"},
      {value: 2, label: "Edit"},
      {value: 3, label: "Remove"},
      {value: 4, label: "AAREdit"},
    ],
    button: "Manage"
  },
  briefcase: {
    display: "Briefcase",
    values: [
      {value: 1, label: "View"},
      {value: 2, label: "Edit"},
      // {value: 3, label: "Remove"},
      {value: 4, label: "Delete"},
      {value: 5, label: "Callback"},
    ],
    button: "Manage"
  },
  cameras: {
    display: "Cameras",
    values: [
      {value: 1, label: "AccessAssigned"},
      {value: 2, label: "AccessAll"},
      {value: 3, label: "Debug"},
      {value: 4, label: "Permissions"},
    ]
  },
  lms: {
    display: "LMS",
    values: [
      {value: 1, label: "View"},
      {value: 2, label: "Edit"},
      {value: 3, label: "Remove"},
      {value: 4, label: "Blacklist"},
    ],
    button: "Manage"
  },
  // leads: {
  //   display: "Leads (match LMS for now)",
  //   values: [
  //     {value: 1, label: "View"},
  //     {value: 2, label: "Edit"},
  //     {value: 3, label: "Remove"},
  //     {value: 4, label: "Blacklist"},
  //   ]
  // },
  intakes: {
    display: "Intakes",
    values: [
      {value: 1, label: "View"},
      {value: 2, label: "Edit"},
      {value: 3, label: "Remove"},
    ]
  },
  taxes: {
    display: "Tax Center",
    values: [
      {value: 1, label: "View"},
      {value: 2, label: "Edit"},
      {value: 3, label: "Remove"},
      {value: 4, label: "ListAll"},
    ],
    button: "Manage"
  },
  events: {
    display: "Event Calendar",
    values: [
      {value: 1, label: "Invite Only"},
      {value: 2, label: "List All"},
      {value: 3, label: "Remove"},
    ]
  },
  store: {
    display: "Store",
    values: [
      {value: 1, label: "View"},
      {value: 2, label: "Edit"},
      {value: 3, label: "Remove"},
    ]
  },
  resources: {
    display: "Resources",
    values: [
      {value: 1, label: "View"},
      {value: 2, label: "Edit"},
      {value: 3, label: "Remove"},
    ]
  },
  training: {
    display: "Training",
    values: [
      {value: 1, label: "View"},
      {value: 2, label: "Edit"},
      {value: 3, label: "Remove"},
      {value: 4, label: "Report"},
    ]
  },
  reviews: {
    display: "Review Center",
    values: [
      {value: 1, label: "AddOwn"},
      {value: 2, label: "AddAll"},
      {value: 3, label: "Approve/Remove"},
    ]
  },
  careers: {
    display: "Careers",
    values: [
      {value: 1, label: "View"},
      {value: 2, label: "Edit"},
      {value: 3, label: "Remove"},
    ]
  },
  splash: {
    display: "Splash Banner",
    values: [
      {value: 1, label: "View"},
      {value: 2, label: "Edit"},
      {value: 3, label: "Remove"},
    ]
  },
  users: {
    display: "User Admin",
    values: [
      {value: 1, label: "View"},
      {value: 2, label: "Edit"},
      {value: 3, label: "Remove"},
      {value: 5, label: "Simulate"},
    ]
  },
  sms: {
    display: "SMS",
    values: [
      {value: 1, label: "Read/Notification"},
      // {value: 2, label: "Reply"},
      {value: 3, label: "Remove"},
      // {value: 5, label: "Compose"},
    ]
  },
  oldportal: {
    display: "Old Portal",
    values: [
      {value: 1, label: "Allow Access"}
    ]
  },
  timeclock: {
    display: "Time Clock",
    values: [
      {value: 1, label: "Employee"},
      {value: 2, label: "Manager"},
    ]
  }
}



// WEBPACK FOOTER //
// ./src/api/permissionHelper.js